import {Route, Routes} from 'react-router-dom';

import {Detail} from './Detail';

export default function TenantCompany() {

  return (
    <Routes>
      <Route path="/" element={<Detail/>}/>
    </Routes>
  );
}
